export default __webpack_public_path__ + "static/media/research.d01bea4d.jpg";